(ns net.kestec.mhda-pilgrimage.route
  (:require [re-frame.core :as rf]
            [reitit.frontend.controllers :as rfc]
            [reitit.frontend.easy :as easy]))

(rf/reg-sub ::route #(get % ::route))

(defmulti content
  (fn [{{:keys [name]} :data}]
    name))

(rf/reg-event-fx
 ::navigated
 (fn [{{:as db
        old-route ::route
        old-controller ::controller}
       :db}
      [_ new-route]]
   {:db (assoc db
               ::route new-route
               ::controller (rfc/apply-controllers
                             old-controller new-route))}))

(rf/reg-fx
 ::replace-state
 (fn [{:keys [route path-params query-params]}]
   (easy/replace-state route
                       (or path-params {})
                       (or query-params {}))))

(rf/reg-fx
 ::push-state
 (fn [{:keys [route path-params query-params]}]
   (easy/push-state route
                    (or path-params {})
                    (or query-params {}))))

(rf/reg-event-fx
 ::push
 (fn [_ [_ route & {:keys [path-params query-params]}]]
   {::push-state
    {:route route
     :path-params path-params
     :query-params query-params}}))

(rf/reg-event-fx
 ::replace
 (fn [_ [_ route & {:keys [path-params query-params]}]]
   {::replace-state
    {:route route
     :path-params path-params
     :query-params query-params}}))

(rf/reg-sub
 ::path-param
 (fn [{{pp :path-params}
       ::route}
      [_ param]]
   (get pp param)))
